import { render, staticRenderFns } from "./printPurInquiry.vue?vue&type=template&id=13b771c2&scoped=true&"
import script from "./printPurInquiry.vue?vue&type=script&lang=js&"
export * from "./printPurInquiry.vue?vue&type=script&lang=js&"
import style0 from "./printPurInquiry.vue?vue&type=style&index=0&id=13b771c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b771c2",
  null
  
)

component.options.__file = "printPurInquiry.vue"
export default component.exports